import prefetchResultToBase64 from "../../prefetchResultToBase64";
import saveBlobToUri from "../../saveBlobToUri";
import CommonPrefetchedData from "../CommonPrefetchedData";

class MemoryOptimizedPrefetchedData extends CommonPrefetchedData {
	constructor(url: string, args: { fetchDelay?: number; lazy?: boolean } = {}) {
		super(url, args);

		// I couldn't find a good way to prefetch without eating memory
		//this.delay().then(this.initialFetch);
		//this.delay().then(this.initialHeadFetch);
		// Therefore web is always effectively lazy
		const cache: {
			initialFetch?: ReturnType<CommonPrefetchedData["initialFetch"]>;
			initialHeadFetch?: ReturnType<CommonPrefetchedData["initialHeadFetch"]>;
		} = {};
		const cachedFunctionFactory = <TKey extends keyof typeof cache>(
			key: TKey,
			fn: () => NonNullable<(typeof cache)[TKey]>,
		) => {
			return (() => {
				if (cache[key]) return cache[key];
				const promise = fn();
				cache[key] = promise;
				promise.finally(() => {
					setTimeout(() => {
						delete cache[key];
					}, 5000);
				});
				return promise;
			}) as typeof fn;
		};
		const cacheContentFetch = cachedFunctionFactory("initialFetch", this.initialFetch);
		const cacheHeadFetch = cachedFunctionFactory("initialHeadFetch", this.initialHeadFetch);

		this.blob = () => cacheContentFetch().then(({ blob }) => blob);
		this.contentType = () => cacheHeadFetch().then(({ contentType }) => contentType);
		this.ext = () => cacheHeadFetch().then(({ ext }) => ext);

		this.base64WithoutPrefix = () =>
			cacheContentFetch().then(({ blob }) =>
				prefetchResultToBase64({
					blob,
					uri: undefined,
				}),
			);

		this.uri = () => cacheContentFetch().then(({ blob, ext }) => saveBlobToUri(blob, ext));

		this.metadata = () =>
			cacheHeadFetch().then(({ contentType, ext, contentDisposition, contentLength }) => ({
				contentType,
				ext,
				contentDisposition,
				contentLength,
			}));

		this.validate();
	}
}
export default MemoryOptimizedPrefetchedData;
